import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const PreviewIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"preview"} ref={ref}/>
});

PreviewIcon.displayName = "PreviewIcon";
